import React, { memo, useEffect, useReducer } from 'react'
import { reducerDeepCompare } from 'components/utils/useStateDeepEqual'
import useContextTheme from 'components/utils/useContextTheme'

import { Source, Layer } from "!react-map-gl"
import { featureFromCoordinates } from './mapUtils'

function Boundary({
  boundaries,
  geoJSON,
  ...props
}) {

  const themeContext = useContextTheme()
  const { theme, themeClass } = themeContext
  const [boundaryGeoJSON, setBoundaryGeoJSON] = useReducer(reducerDeepCompare, geoJSON)

  const showLabels = theme?.map?.boundary?.show_labels ?? false
  const boundaryLabelStyles = {
    id: 'boundaries-label',
    type: 'symbol',
    layout: {
      "text-allow-overlap": true,
      'text-field': ['get', 'name'],
      'text-font': [
        "Public Sans Bold",
        "Arial Unicode MS Regular"
      ],
      'text-size': 14
    },
    paint: {
      'text-color': theme?.map?.boundary?.label_color || 'rgba(25, 25, 26, 0.7)',
      'text-halo-color': 'rgba(255, 255, 255, 0.8)',
      'text-halo-width': 1,
    }
  }


  // TODO: Allow colors to be set by theme
  const boundaryFillStyles = {
    id: 'boundaries-fill',
    type: 'fill',
    paint: {
      'fill-color': theme?.map?.boundary?.fill_color || 'hsl(253, 74%, 68%)',
      'fill-opacity': theme?.map?.boundary?.fill_opacity ?? 0.1
    }
  }

  const boundaryLineStyles = {
    id: 'boundaries-line',
    type: 'line',
    paint: {
      'line-color': theme?.map?.boundary?.line_color || 'hsl(253, 74%, 68%)',
      'line-opacity': theme?.map?.boundary?.line_opacity ?? 0.8,
      'line-dasharray': theme?.map?.boundary?.line_dash_array || [4, 3],
      'line-width': theme?.map?.boundary?.line_weight || 4
    }
  }

  //console.log('boundaryLineStyles ', theme?.map?.boundary?.fill_opacity, boundaryFillStyles, boundaryLineStyles);

  // Takes a GeoJSON object or array of points and creates a polygon
  const boundaryDep = JSON.stringify(boundaries)
  useEffect(() => {
    // Only set the boundaryGeoJSON if boundaries is not null
    if (boundaries && (geoJSON == null || geoJSON.length == 0)) {
      let turfFeature = featureFromCoordinates(boundaries)
      if (turfFeature) setBoundaryGeoJSON(turfFeature)
    }
  }, [boundaryDep])

  return (
    <Source id='boundaries' type="geojson" data={boundaryGeoJSON}>
      {showLabels ? <Layer {...boundaryLabelStyles} /> : null}
      <Layer {...boundaryFillStyles} beforeId='road-label' />
      <Layer beforeId='road-label' {...boundaryLineStyles} />
    </Source>
  )
}

export default memo(Boundary)
